<h1 class="title-modal-add-user" mat-dialog-title>
  <strong>Details of : {{ data.name }}</strong>
  <mat-icon class="close-btn" (click)="onNoClick()">close</mat-icon>
</h1>
<mat-divider></mat-divider>
<div class="mat-dialog-content">
  Are you sure you want to delete <strong>{{ data.name }}</strong> ?
</div>
<mat-divider></mat-divider>
<div class="btn-container" mat-dialog-actions>
  <button mat-stroked-button color="warn" (click)="onRemove()">Delete</button>
</div>
